import { Link } from 'react-router-dom';
import { AnimatedSection, StaggerChildren, StaggerItem } from '../components/AnimatedSection';

const ARCHITECTURE_IMAGE = "https://customer-assets.emergentagent.com/job_elite-clarity/artifacts/u5uxl7tl_pexels-gonchifacello-1432039.jpg";

const services = [
'Private conversations',
'Performance debriefs',
'Competition support',
'Leadership conversations',
'Team and organisational insight work'];


const experiences = [
{ title: 'Greater clarity', subtitle: 'under pressure' },
{ title: 'A deeper sense', subtitle: "of purpose" },
{ title: 'Freedom from', subtitle: 'overthinking' },
{ title: 'Renewed enjoyment', subtitle: 'in performance' }];


export const TheWork = () => {
  return (
    <div data-testid="the-work-page" className="bg-[#050505]">
      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-end pb-12 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={ARCHITECTURE_IMAGE}
            alt="The Work"
            className="w-full h-full object-cover opacity-30" />

          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/80 to-transparent" />
        </div>

        <div className="relative z-10 max-w-[1200px] mx-auto px-6 md:px-12 w-full">
          <AnimatedSection>
            <p className="caption-text mb-6">The Work</p>
            <h1 className="heading-large">There is no fixed programme.</h1>
          </AnimatedSection>
        </div>
      </section>

      {/* Approach Section */}
      <section className="section-padding pt-12">
        <div className="max-w-[1200px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
            <AnimatedSection>
              <p className="body-large mb-8">
                Every Paragon relationship begins with a conversation.
              </p>
              <p className="body-text mb-8">
                From there we design the work around the individual and the environment they perform in.
              </p>
              <p className="body-text">
                This may include:
              </p>
            </AnimatedSection>

            <AnimatedSection delay={0.2}>
              <StaggerChildren className="space-y-4">
                {services.map((service, index) =>
                <StaggerItem key={index}>
                    <div className="flex items-center gap-4 py-4 border-b border-white/10">
                      <span className="text-white/30 text-xs">{String(index + 1).padStart(2, '0')}</span>
                      <span className="text-white text-lg">{service}</span>
                    </div>
                  </StaggerItem>
                )}
              </StaggerChildren>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="section-padding bg-[#0A0A0A]">
        <div className="max-w-[800px] mx-auto text-center">
          <AnimatedSection>
            <div className="border-y border-white/10 py-16">
              <p className="text-white font-['Playfair_Display'] text-2xl md:text-3xl leading-relaxed">
                Our aim is never to add more.<br />
                <span className="text-white/60">It is to remove what gets in the way.</span>
              </p>
            </div>
          </AnimatedSection>
        </div>
      </section>

      {/* The Paragon Experience */}
      <section data-testid="experience-section" className="section-padding">
        <div className="max-w-[1200px] mx-auto">
          <AnimatedSection>
            <p className="caption-text mb-6">The Paragon Experience</p>
            <h2 className="heading-medium mb-4">
              Clients often report experiencing:
            </h2>
          </AnimatedSection>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16">
            {experiences.map((exp, index) =>
            <AnimatedSection key={index} delay={0.1 * (index + 1)}>
                <div className="glass-card">
                  <p className="text-white font-['Playfair_Display'] text-xl md:text-2xl">
                    {exp.title}
                  </p>
                  <p className="text-[#666] mt-2">{exp.subtitle}</p>
                </div>
              </AnimatedSection>
            )}
          </div>

          <AnimatedSection delay={0.6} className="mt-16 text-center">
            <p className="body-text mb-2">
              Not because something new was added.
            </p>
            <p className="text-white italic">
              But because something unnecessary fell away.
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-[#0A0A0A]">
        <div className="max-w-[600px] mx-auto text-center">
          <AnimatedSection>
            <p className="body-text mb-8">
              Experience the Paragon approach.
            </p>
            <Link to="/apply" data-testid="work-apply-btn" className="btn-primary">
              Begin the Conversation
            </Link>
          </AnimatedSection>
        </div>
      </section>
    </div>);

};